import {LoggedIn,ResumeFsm,Logout,Deactivate,Activate} from '@/store/modules/fsm/messages';
import { post } from '@/store/modules/fsm/index';

export default ({regionName,activations,activeIndex,
  dormantToReady = ()=>{},
  readyToDormant = ()=>{},
  deactivation = ()=>{}
}) =>
  ({tree,parent,api}) => {
    if(!tree)
    {
      let { addState, addRegion, PseudoStateKind} = api;
      let here = addRegion(regionName,parent);
      addState('init',here,PseudoStateKind.ShallowHistory);
      addState('dormant',here);
      addState('ready',here);
      addState('active',here);
      addState('activating',here);
      activations.forEach(activation => {
        addState(activation.name,here.activating);
        addState(activation.name,here.active);
      });
    }
    else
    {
      let { messageIs, nextRouterHook  } = api;
      let here = parent[regionName];
      here.init
        .to(here.dormant);
      here.dormant
        .to(here.ready)
        .when(messageIs(LoggedIn,ResumeFsm))
        .effect(dormantToReady);
      here.ready
        .to(here.dormant)
        .when(messageIs(Logout))
        .effect(readyToDormant);
      activations.forEach(activation => {
        here.ready
          .to(here.activating[activation.name])
          .when(activation.test)
          .effect(({}={},{next})=>post({message:Deactivate,next}));
        here.activating[activation.name]
          .to(here.active[activation.name])
          .when(messageIs(Activate))
          .effect(nextRouterHook);
        here.active[activation.name]
          .to()
          .when(activation.test)
          .effect(nextRouterHook);
      });
      here.activating
        .to()
        .when(messageIs(Deactivate))
        .effect(({}={},{next})=>post({message:Activate,next}));
      here.active
        .to(here.ready)
        .when(messageIs(Deactivate))
        .effect(deactivation)
    }
    let here = parent[regionName];
    activeIndex({tree,parent:here,api});
  };
